import fromAnyToString from 'utils/converters/fromAnyToString';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const RE_PERIOD_ONE = /\.+/;
const RE_COMMA_ONE = /,+/;
const RE_COMMA_ALL = /,+/g;
const RE_CLEAR_ALL_BUT_LAST = /\.(?=.*\.)/g;

const fromAnyToDecimal = (value) => {
  if (Number.isFinite(value) || Number.isNaN(value) || Infinity === value || -Infinity === value) {
    return value;
  }

  const initialString = fromAnyToString(value);

  const hasComma = isFullArray(initialString.match(RE_COMMA_ONE));
  const hasPeriod = isFullArray(initialString.match(RE_PERIOD_ONE));

  // if there aren't commas, nor periods, no need to do extra work
  if (!hasComma && !hasPeriod) return value;

  const noCommaString = initialString.replace(RE_COMMA_ALL, '.');

  // now there are no periods and no commas, return the string
  if (!isFullArray(noCommaString.match(RE_PERIOD_ONE))) return noCommaString;

  // at this point there is a period, maybe more than one, so remove all but the last one
  return noCommaString.replace(RE_CLEAR_ALL_BUT_LAST, '');
};

export default fromAnyToDecimal;
